<template>
	<div class="relative-position bg-black" v-if="courses.length > 0">
		<div class="row q-pa-md">
			<div class="col-12 text-h6 text-white q-mb-md keep">
				{{ $t('keep_watching') }}
			</div>

			<div class="col-12">
				<q-scroll-area horizontal :visible="false" style="height: 260px" class="scroll-hidden">
					<div class="row no-wrap q-col-gutter-sm" style="max-width: 100vw">
						<div class="col-5" v-for="(training, index) in courses" :key="index">
							<training
								:course="training"
								:content="training"
								@favorite="toggleFavorite"
								@like="toggleLike"
								@review="toggleReviews"
							/>
						</div>

						<div class="col-xs-5 col-sm-3" v-if="ispage === 'home'">
							<q-card
								class="full-height shadow-transition cursor-pointer card-empty bg-grey-9"
								:class="class_hover"
								dark
								@mouseover="class_hover = 'shadow-5'"
								@mouseleave="class_hover = ''"
								@click="$router.push({ name: 'courses' })"
							>
								<q-card-section class="absolute-center full-width text-center">
									<p class="q-mt-sm text-body1">
										{{ $t('see_all_content') }}
									</p>
									<q-btn flat color="white" icon="fas fa-arrow-right" />
								</q-card-section>
							</q-card>
						</div>
					</div>
				</q-scroll-area>
			</div>
		</div>

		<q-dialog :maximized="$q.platform.is.mobile" v-model="show_reviews">
			<user-reviews module="courses" :moduleData="course_to_review" />
		</q-dialog>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</div>
</template>

<script>
import Training from 'components/courses/mobile/Course'
import UserReviews from 'components/shared/mobile/UserReviews'
// Composables
import useFavoriteModule from 'src/composables/useFavoriteModule'
import useLikeModule from 'src/composables/useLikeModule'

export default {
	name: 'HomeKeepWatchingCoursesMobile',

	components: {
		training: Training,
		'user-reviews': UserReviews,
	},

	data() {
		return {
			courses: [],
			loading: false,
			slide: 1,
			ispage: '',
			class_hover: '',
			show_reviews: false,
			course_to_review: null,
		}
	},

	computed: {
		paginatedTrainings() {
			let chunks = []
			let i = 0
			let n = this.courses.length

			while (i < n) {
				chunks.push(this.courses.slice(i, (i += 4)))
			}
			return chunks
		},
	},

	methods: {
		getKeepWatchingCourses() {
			this.loading = true

			let data = {
				page_type: this.ispage,
			}

			this.$axios
				.get(
					`/etraining_courses/group_trainings/group_training_keep_watching/?${this.$qs.stringify(
						data
					)}`
				)
				.then((response) => {
					this.courses = response.data
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		async toggleFavorite(id) {
			try {
				this.loading = true
				await this.favoriteCourse('courses', this.courses, 'favorited', id)
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},

		async toggleLike(id) {
			try {
				this.loading = true
				await this.likeCourse('courses', this.courses, 'liked', id)
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},

		toggleReviews(id) {
			let obj = this.courses.find((obj) => {
				return obj.id === id
			})
			this.course_to_review = obj
			this.show_reviews = true
		},
	},

	created() {
		this.ispage = this.$route.name
		this.getKeepWatchingCourses()
	},

	setup() {
		const favoriteCourse = useFavoriteModule()
		const likeCourse = useLikeModule()

		return {
			favoriteCourse,
			likeCourse,
		}
	},
}
</script>

<style lang="scss" scoped>
.q-carousel {
	background-color: inherit;
}
.keep {
	font-weight: 800;
}
</style>
